export const darkTheme = {
  bg: "#090917",
  bgLight: "#1C1E27",
  primary: "#854CE6",
  text_primary: "#F2F3F4",
  text_secondary: "#b1b2b3",
  card: "#171721",
  card_light: "#191924",
  button: "#854CE6",
  white: "#FFFFFF",
  black: "#000000",
};

export const lightTheme = {
  bg: "#FFFFF2",
  bgLight: "#FF5A36",
  primary: "#FF4400",
  text_primary: "#FF7519",
  text_secondary: "#FF9F01",
  card: "#FFFFFF",
  button: "#FFFFF4",
  white: "#FFFFFF",
  black: "#000000",
  card_light: "#000000",
};
